import { EditAccountWebComponent } from './component/EditAccountWebComponent';
import { WEB_COMPONENT_EDIT_ACCOUNT_PANEL } from '../../webcomponents.constants';

export { EditAccountWebComponent };

window.customElements.define(WEB_COMPONENT_EDIT_ACCOUNT_PANEL, EditAccountWebComponent);
